import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';

import Dialog, { DialogProps } from '@mui/material/Dialog';

import ScrollDialog from './EditDialog';
export function NoteToolBar() {
	const sx = {
		backgroundColor: '#eeeeee',
		display: 'flex',
		height: 45,
		width: '100%',
		paddingLeft: 6,
		paddingRight: 10,
		alignItems: 'center',
	};
	const sxleft = {
		flexGrow: 1,
		//backgroundColor: 'green',
	};
	const sxright = {
		flexGrow: 4,
		//backgroundColor: 'yellow',
	};
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');

  const handleClickOpen = (scrollType: DialogProps['scroll']) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
	  console.log('is this closing happening?');
    setOpen(false);
  };

  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

	return (
		<Box position="fixed" sx={sx}>
			<Box sx={sxleft}>
				<Typography>Notes</Typography>
			</Box>
			<Box sx={sxright}>
				<Button
					variant="outlined"
					startIcon={<AddIcon />}
					size="small"
					onClick={handleClickOpen('paper')}
				>
					Add Note
				</Button>
			</Box>
			<ScrollDialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
			/>
		</Box>
	)
}
